import { DesignStepName, StepName } from '~/core/enums';

export const firstStep = StepName.store;

export const lastStep = StepName.orderSummary;

export const designSteps: DesignStepName[] = [
  StepName.designShape,
  StepName.designEdge,
  StepName.designCornerRadius,
  StepName.designDiagonalCorner,
  StepName.designCustomSide,
  StepName.designSink,
  StepName.designCookingAppliance,
  StepName.designCutout,
  StepName.designTearOut,
  StepName.designAddOn,
  StepName.designPlumbing,
];

export const allSteps: StepName[] = [
  StepName.store,
  StepName.material,
  StepName.color,
  ...designSteps,
  StepName.orderSummary,
];
